const TableHeadTdOrder = ({title, fieldName, value, desc=false, onClick,
        className="cursor-pointer d-flex align-items-center"
    }) => {
        
    return (<>
        <span className={className}
            onClick={()=>{
                onClick(fieldName, (value == fieldName) ? !desc : false);
            }}>
            {title} 

            {value == fieldName && (
                <i className={`bi bi-caret-${desc?'up':'down'}-fill fs-18 p-0 ms-1 text-muted`}></i>)}

            </span>
    </>)
}

export default TableHeadTdOrder; 